(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (evt) => {
  const btn = evt.target.closest('.coll-filter');
  if (!btn) return;
  const section = btn.closest('.cc-collection-list');
  if (!section) return;

  const filter = btn.dataset.filter;
  section.querySelectorAll('.coll-filter').forEach((b) => {
    b.classList.toggle('is-active', b === btn);
  });
  section.querySelectorAll('.main-collections-grid > li').forEach((li) => {
    const group = (li.dataset.filterGroup || '').trim();
    li.hidden = !(filter === '__all' || group === filter);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-spotlight"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (evt) => {
  const btn = evt.target.closest('.js-es-sound');
  if (!btn) return;

  const video = btn.closest('.edit-spot__video-wrap').querySelector('video');
  if (!video) return;

  video.muted = !video.muted;
  if (!video.muted && video.paused) video.play();

  btn.classList.toggle('is-unmuted', !video.muted);
  btn.setAttribute('aria-label', video.muted ? 'Aktivizo zërin' : 'Çaktivizo zërin');
});

// Pause spotlight videos when off-screen. Mobile Safari caps how many videos
// may play at once, so keeping these playing starves videos further down the
// page (e.g. a background-video section) of a playback slot.
(() => {
  if (!('IntersectionObserver' in window)) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting) {
        if (video.paused) video.play().catch(() => {});
      } else if (!video.paused) {
        video.pause();
      }
    });
  }, { rootMargin: '0px 0px 200px 0px' });

  const observeAll = () => {
    document.querySelectorAll('.edit-spot__video').forEach((v) => io.observe(v));
  };
  observeAll();
  document.addEventListener('shopify:section:load', observeAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
